import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import cs from 'classnames'
import {filter} from 'lodash/collection'
import styles from './sidebar.scss'
import Disclaimer from '../disclaimer'
import {toggleMenu} from 'state/actions'
import underscore from 'underscore'
import i18n from 'lib/i18n'

const _ = i18n('sidebar')

@connect(
	state => ({
		module: state.app.module,
		security: state.app.security,
		menuCollapsed: state.app.menuCollapsed,
		subMenuCollapsed: state.app.subMenuCollapsed,
		isPhone: state.responsive.isPhone,
		isTablet: state.responsive.isTablet,
		unreadCount: state.inbox.unreadCount,
		taskCount: state.taskList.uncompleted,
		outboxFailedCount: state.outbox.outboxFailedCount,
		newNewsCount: state.news.newNewsCount,
		isIe: state.app.isIE,
	}),
	{toggleMenu}
)
export default class Sidebar extends Component {
	static propTypes = {
		isPhone: PropTypes.bool,
		isTablet: PropTypes.bool,
		className: PropTypes.string,
		module: PropTypes.string.isRequired,
		security: PropTypes.object,
		menuCollapsed: PropTypes.bool,
		subMenuCollapsed: PropTypes.bool,
		inbox: PropTypes.array,
		unreadCount: PropTypes.number,
		taskCount: PropTypes.number,
		outboxFailedCount: PropTypes.number,
		onLinkClicked: PropTypes.func.isRequired,
		onLogout: PropTypes.func.isRequired,
		onSubmenuClick: PropTypes.func.isRequired,
		toggleMenu: PropTypes.func.isRequired,
		newNewsCount: PropTypes.number,
    }
    /**
     * This is a recursive sidebar menu generator. There are used submenus but use it carrefully,
     * because all of the submenus try to find a module. The menu generator is dynamic but the
     * paths must exists in the module tree.
     */
    MenuItemDom = ({item, onClick, onSubmenuClick, hasParent = false, key = 0}) => {
        const {isPhone, isTablet, unreadCount, taskCount, outboxFailedCount, subMenuCollapsed, onLinkClicked} = this.props
        const isActive = this.isActiveItem(item)
        const name = this.getMenuName(item)
        const count = this.getCountIndicatorValue(item)
        const isCollapsed = (Boolean(subMenuCollapsed) ? false : true)
        const childrens = (underscore.isEmpty( item.childrens ) ? [] : item.childrens)
        const icon = this.getIcon(item.menuName)

        return React.createElement("li",
			{
                key: key,
				onClick: !underscore.isEmpty(childrens) ? onSubmenuClick : (e) => onClick(e,hasParent),
				className: cs(
                    styles.linkWrapper,
					styles[item.menuName],
					isActive && styles.active
				)
			},
			<div className={cs(styles.link)}>
				<img src={icon}/>
				<span className={cs(styles.menuTitle, (isPhone || isTablet) && styles.extraStyle)}>
					{name}
				</span>
				{count > 0 && <div className={styles.inboxCounter}>{count}</div>}
			</div>,
			(!isCollapsed && !underscore.isEmpty(childrens) && underscore.isArray(childrens)) ?
			<ul className = {cs(styles.linkWrapper, styles.isParentMenuContent)}>
				{childrens.map((subItem, i) => (
					this.MenuItemDom({
                        item: subItem,
                        key: key + "_" + i,
                        onClick: (e, hasParent) => {e.stopPropagation(); onLinkClicked(subItem.menuName, false, hasParent, subItem || null)},
                        onSubmenuClick: () => {onSubmenuClick(subItem.menuName)},
                        hasParent: true
					})
				))}
			</ul>
			: null
    )}
    handleToggle = () => this.props.toggleMenu()
    getIcon = menuName => {
        try {
            return require(`resources/images/icn-${menuName}.svg`)
        }catch(err){
            return require(`resources/images/icn-no-result.svg`)
        }
    }
    getContainerClassNames = () => cs(
        styles.sidebarContainer,
        (this.props.isPhone || this.props.isTablet) && styles.mobile,
        this.props.menuCollapsed ? styles.collapsed : styles.opened,
        this.props.className
    )
    getLogoImg = () => (
        this.props.menuCollapsed ? <img src={require('resources/images/BE_Logo_OVB_Willemot_White.svg')}/> :
        <img src={require('resources/images/BE_Logo_OVB_Willemot_Blue_cmyk.svg')}/>
    )
    getLogoElement = () => (
        <div onClick={() => this.props.onLinkClicked(null)} className={styles.navLogo}>
            {this.getLogoImg()}
        </div>
    )
    /*
     * This helps to provide number indicator value for the sidebar menu elements.
     */
    getCountIndicatorValue = (item) =>
		(item.menuName === 'inbox' && this.props.unreadCount)
		|| (item.menuName === 'tasklist' && this.props.taskCount)
		|| (item.menuName === 'outbox' && this.props.outboxFailedCount)
		|| (item.menuName === 'news' && this.props.newNewsCount)
    isActiveItem = (item) => item && (item.menuName.toLowerCase() === this.props.module.toLowerCase())
    getMenuName = (item) => item && (item.menuLabel || _(item.menuName))

	render() {
		const {module, security, onSubmenuClick, isPhone, isTablet, onLinkClicked, onLogout, isIE} = this.props
		const links = filter(security.menuItems, item => (item.menuVisible === "true"))

		let isIEclass = styles.isIE;

		if(isIE == false)
		{
				isIEclass = null
		}

		return (
			<div className={this.getContainerClassNames() + " " + isIEclass} >
				<div className={styles.sidebarWrapper}>
					{(!isPhone || !isTablet) && this.getLogoElement()}
					<ul>
						{links.map((item, i) =>
							this.MenuItemDom({
                                item: item,
                                key: i,
                                onClick: () => {onLinkClicked(item.menuName)},
                                onSubmenuClick: () => {onSubmenuClick(item.menuName)}
							})
						)}
						{this.MenuItemDom({
                            item: { menuName: 'logout' },
                            key: 99999, // last one menu
                            onClick: onLogout
                        })}
					</ul>
					<div className={styles.sidebarFooter}>
						<div className={styles.disclaimer}>
							<Disclaimer/> <br/>
							{`© ${(new Date()).getFullYear()} WILLEMOT NV`}
						</div>
						{!isPhone && !isTablet &&
							<div onClick={this.handleToggle} className={styles.collapseArrow}>
								<img src={require('resources/images/pro-arrow_2x.png')}/>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/mainComponents/sidebar.jsx